import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Nav from 'react-bootstrap/Nav';

const StakeNav = () => {
  const { pathname } = useRouter();

  return (
    <Nav
      variant="pills"
      className="justify-content-center fw-bold"
      activeKey={pathname}
    >
      <Nav.Item>
        <Link href="/stake/noundles" passHref>
          <Nav.Link>Stake Noundles</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link href="/stake/companions" passHref>
          <Nav.Link>Stake Frendles</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link href="/stake/evil-noundles" passHref>
          <Nav.Link>Stake Ruggles</Nav.Link>
        </Link>
      </Nav.Item>
    </Nav>
  );
};

export default StakeNav;
